import { render, staticRenderFns } from "./InstallationDetail_Actioncam.vue?vue&type=template&id=650942a7&"
import script from "./InstallationDetail_Actioncam.vue?vue&type=script&lang=js&"
export * from "./InstallationDetail_Actioncam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports